import React from 'react';
import MathQuilElement from './MathQuilElement.jsx'
import PlainButton from '../common/PlainButton';
import ToolTip from '../common/ToolTip.js';
import TooltipSlider from './TooltipSlider'

class SliderComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    static getDerivedStateFromProps = (props, state) => {
        if(state.showRangeEditor || state.valueChange) {
            state.valueChange = false;
            return state;
        }
        // Set inputbox value to props.val when val is changed externally
        if(state.val != props.val) {
            state.valTemp = props.val
        }
        return {
            min: props.min,
            max: props.max,
            val: props.val,
            // Set state.valTemp if it exists
            valTemp: state.valTemp || props.val,
            step: props.step || SliderComponent.getStepValue(props.max - props.min)
        }
    }

    // To calculate step value
    static getStepValue = (n) => {
        let order = Math.floor(Math.log(n) / Math.LN10
                            + 0.000000001); // because float math sucks like that
        let orderOfMagnitude = Math.pow(10,order);
        return orderOfMagnitude / 100;
    }

    // Call onchange
    _triggerOnChange = () => {
        this.props.onChange({
            min: this.state.min,
            max: this.state.max,
            val: this.state.val,
            step: this.state.step,
        })
    }

    // Triger value change after 200ms to avoid min and max override
    _updateValWithDelay = (v) => {
        let Dyn = this.props.Dyn;
        if(this._updateTimer) {
            clearTimeout(this._updateTimer)
        }
        // Ignore invalid value update
        if(!v || isNaN(v)) {
            return;
        }
        this._updateTimer = setTimeout(() => {
            this.state.val = parseFloat(v);
            if(this.state.min > this.state.val) {
                this.state.min = this.state.val;
            }
            if(this.state.max < this.state.val) {
                this.state.max = this.state.val;
            }
            let d = Dyn.mathUtil.decimalPlaces(this.state.val),
                s = Dyn.mathUtil.decimalPlacesToIntervalWidth(d);
            if( this.state.step > s ) {
                this.state.step = s; // step size <= decimal places in val (e.g. 8.12 -> step 0.01)
            }
            this._triggerOnChange()
        }, 300)
    }

    // To handle slider value changes
    _handleSliderChange = (v) => {
        this.state.val = v;
        // To force to update value of input box to the value got from this.props
        this.state.valTemp = undefined;
        this._triggerOnChange();
    }

    // To handle input element changes
    _handleOnChange = (v, prop) => {
        this.state[prop] = v;
        // Update with delay for Input Field
        if(prop === 'valTemp') {
            this.state.valueChange = true;
            this._updateValWithDelay(v);
        }
        this.forceUpdate();
    }

    // Fix val on blur
    _handleBlur = () => {
        // Reset to last valid value
        this.setState({
            valTemp: this.props["val"]
        });
    }

    // Fix values
    _fixValue = (prop) => {
        this.state[prop] = (!this.state[prop] || isNaN(this.state[prop]))? this.props[prop] : parseFloat(this.state[prop]);
    }

    // Open the min and max range editor
    _openRangeEditor = () => {
        this.setState({
            showRangeEditor: true
        })
    }

    // Close the min and max range editor
    _closeRangeEditor = () => {
        this._fixValue('min');
        this._fixValue('max');
        this._fixValue('step');
        // Update max value if it is less than min value
        if(this.state.val < this.state.max && this.state.min > this.state.max) {
            this.state.max = this.state.min + 10;
        }
        // Update min value if it is grater than max value
        if(this.state.val > this.state.min && this.state.min > this.state.max) {
            this.state.min = this.state.max - 10;
        }
        // Fix val when it is not between min and max range
        if(this.state.val > this.state.max || this.state.val < this.state.min) {
            this.state.val = (this.state.max + this.state.min) / 2;
        }
        this.state.valTemp = this.state.val;
        this.state.showRangeEditor = false;
        this._triggerOnChange();
    }

    // To handle enter key while editing on the min and max range input boxes
    _handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this._closeRangeEditor();
        }
    }

    _getEditButton = () => {
        return !this.state.showRangeEditor && <ToolTip tip={this.props.Dyn.loc('Edit Constant {{constant}}', {"constant": this.props.name})} Dyn={this.props.Dyn}>
                                                <PlainButton className="tde-clickable-icon tde-edit-slider-val tde-d-flex"
                                                    onClick={this._openRangeEditor} aria-label={this.props.Dyn.loc('Edit Constant {{constant}}', {"constant": this.props.name})}>
                                                        <i className="tde-i tde-i-pencil"></i>
                                                </PlainButton>
                                            </ToolTip>

    }

    _getSaveButton = () => {
        return this.state.showRangeEditor && <ToolTip tip={this.props.Dyn.loc('Save Constant {{constant}}', {"constant": this.props.name})} Dyn={this.props.Dyn}>
                                                <PlainButton className="tde-clickable-icon tde-edit-slider-val tde-d-flex"
                                                    onClick={this._closeRangeEditor} aria-label={this.props.Dyn.loc('Save Constant {{constant}}', {"constant": this.props.name})}>
                                                        <i className="tde-i tde-i-floppy-disk"></i>
                                                </PlainButton>
                                            </ToolTip>

    }

    render = () => {
        return (
            <div className={'tde-range-slider' + (this.props.className? ' '+ this.props.className:'')}>
                <div className='tde-d-flex'>  
                    <div className="tde-d-flex tde-align-center">
                        <span className="tde-var-name tde-s1 tde-pr-1 tde-font-weight-regular">{this.props.name} = </span>
                        <div className="tde-input tde-d-flex tde-input-border tde-flex-1">
                        <input value={this.state.valTemp} name="val" aria-label={"Slider Range Input for constant "+this.props.name}
                            onChange={e => this._handleOnChange(e.target.value, 'valTemp')}
                            onBlur={this._handleBlur} className="tde-slider-val tde-s1 tde-input-text tde-px-2"/></div>
                    </div>
                    <div>
                        { this._getEditButton() }
                        { this._getSaveButton() }
                    </div>
                </div>
                { !this.state.showRangeEditor &&
                    <div className="tde-options tde-ml-4">
                        <div className="tde-d-flex tde-my-2 tde-pb-2">
                            <div onClick={this._openRangeEditor} className="tde-pr-2">{this.props.min}</div>
                            <TooltipSlider Dyn={this.props.Dyn} step={this.state.step} onChange={this._handleSliderChange} min={this.props.min} max={this.props.max} value={this.state.val} ariaLabelForHandle={"Slider Range for constant "+this.props.name} railStyle={{backgroundColor: '#fff'}} />
                            <div onClick={this._openRangeEditor} className="tde-pl-2">{this.state.max}</div>
                        </div>
                    </div>
                }
                { this.state.showRangeEditor &&
                    <div className="tde-range-slider-editor tde-d-flex tde-pb-3 tde-mt-2 tde-ml-4 tde-flex-items-center">
                        <div className="tde-input tde-d-flex tde-flex-1">
                            <input name="min" type="number" autoFocus value={this.state.min} onChange={e => this._handleOnChange(e.target.value, 'min')} onKeyPress={this._handleKeyPress}
                                    className="tde-no-spinners tde-s1 tde-input-text tde-px-1" aria-label={this.props.getLoc('Slider Minimum, Edit Text')} />
                            <div className="tde-var-limit tde-px-1" >
                                <MathQuilElement value={"\\le"}/><span>{this.props.name}</span><MathQuilElement value={'\\le'}/>
                            </div>
                            <input name="max" type="number" value={this.state.max} onChange={e => this._handleOnChange(e.target.value, 'max')} onKeyPress={this._handleKeyPress}
                                    className="tde-no-spinners tde-s1 tde-input-text tde-px-1" aria-label={this.props.getLoc('Slider Maximum, Edit Text')}/>
                            <span className="tde-s1 tde-label tde-px-1 tde-pb-1">{this.props.getLoc('step')}</span>
                            <input name="step" type="number" value={this.state.step} onChange={e => this._handleOnChange(e.target.value, 'step')} onKeyPress={this._handleKeyPress}
                                className="tde-no-spinners tde-step-btn tde-s1 tde-input-text tde-px-1" aria-label={this.props.getLoc('Slider Step Size')}/>
                        </div>

                    </div>
                }
            </div>
        )
    }
}

export default SliderComponent;
